<template>
	 <div class="bread_container">
	 	<span class="bars"> 
		    <i class="el-icon-menu"></i>
		</span>
		<el-breadcrumb class='nav-bread' separator-class="el-icon-arrow-right">
		  	<!-- <el-breadcrumb-item :to="{ path: '/main' }">首页</el-breadcrumb-item> 
            <el-breadcrumb-item 
            	:to="{ path: item.path }" 
                v-for='(item,index) in levelList'
                :key='index'
				v-if='item.name'>
				{{item.name}}
			</el-breadcrumb-item>
		</el-breadcrumb>-->
		<el-breadcrumb-item 
                v-for='(item,index) in levelList'
                :key='index'
				>
				<template v-if='item.name'>{{item.name}}</template>
			</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- <span class="reload"  @click="reloads"><i class="el-icon-refresh"></i>刷新</span> -->
	</div>
</template>


<script>
import {mapMutations} from 'vuex';

export default {
	data(){
		return {
			
			levelList: null,
			changeBarDirection:false
		}
	},
	
	created() {
		this.getBreadcrumb();
		//console.log(this.$route)
    },
	methods:{
		...mapMutations(['handleMenuStore']),
		// reloads(){
		// 		this.reload();
		// },
		getBreadcrumb() {
			
			let matched = this.$route.matched;
			//console.log("matched")
			//console.log(matched)
		
			var breadArr=[];
			
			for (var i = 0; i < matched.length; i++) {
				
				var breadObj={};
				breadObj.name=matched[i].name;
				breadObj.path=matched[i].path;
				// if(matched[1].name=="泊位管理"||matched[1].name=="设备管理"){
				// 	this.refreshActived=true;
				// }else{
				// 	this.refreshActived=false;
				// }
				/*if(matched[i].path=="/main/equip/readcard"){
					breadArr.push({name:"区域",path:"/main/equip/area"})
				}*/
				breadArr.push(breadObj)
			};
			this.levelList = breadArr;
      	},
      	handleLeftMenu(){
      		this.changeBarDirection = !this.changeBarDirection;
      		this.handleMenuStore(this.changeBarDirection);
      	}
	},
	// inject:['reload'],
	watch: {
      $route() {
           this.getBreadcrumb();
      }
    }
}



</script>

<style scoped>
	.bread_container{
		display:flex;
		align-items: center;
		/* background:#f9f9fb; */
		background:white;
		/* border-top:10px solid #eff2f7; */
		margin:10px;
		height:40px;
		padding:0 10px;
		border-radius:5px;
		/* box-shadow:0 0 6px #999; */
		
		
	}
	.nav-bread{
		line-height: 18px;
		float:left;
	}
	.bars{
			float: left;
            margin: 0px 6px;
			/* cursor: pointer; */
	}
	.reload{
		float:left;
		margin: 0px 20px;
		cursor: pointer;
		color:#67C23A!important;
	}
	.bars .el-icon-menu{
		color:#67C23A!important;
	}
</style>


